exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ficheVIsioVente  {\n  width: calc(100% - 26px);\n  margin-left: 6px;\n}\n.ficheVIsioVente .v-text-field.v-text-field--enclosed .v-text-field__details,\n.ficheVIsioVente .v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {\n  padding: 0 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzVisioVente.vue
// module id = ZC64
// module chunks = 1